import SIPExtensions from './SIPExtensions';

export { SIPExtensions };



// WEBPACK FOOTER //
// src/modules/screens/settings/SIPExtensions/components/index.js